import './_active-filter.scss';
import component from './active-filter';

export default component;
